<template>
  <div class="kFormField">
    <label
      v-if="$slots.label || label"
      class="kFormField__label"
    >
      <slot name="label">
        {{ label }}
        <span class="optional"
              v-if="optionalLabel">({{optionalLabel}})</span>
      </slot>
    </label>
    <div
      v-if="$slots.description || description"
      class="kFormField__description"
    >
      <slot name="description">
        {{ description }}
      </slot>
    </div>
    <div class="kFormField__inputWrapper">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  label: String,
  description: String,
  name: String,
  optionalLabel: String,
});
</script>

<style lang="scss" scoped>
  .kFormField {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &__label {
      position: relative;
      width: 100%;
      font-weight: 500;
      color: var(--gray-80);
    }

    &__description {
      margin-bottom: var(--grid-unit);
      color: var(--gray-60);
    }

    &__inputWrapper {
      align-self: stretch;
    }

    .optional {
      color: #616161;
      font-size: calc(var(--grid-unit) * 2);
      font-weight: 400;
    }
  }

  .kFormField + .kFormField {
    margin-top: calc(var(--grid-unit) * 2);
  }

</style>
